import { caption } from '@/styles/typography';
import styled from 'styled-components';

export const StatusPill = styled.span<{ $bg: string; $fg: string }>`
  ${caption};
  display: inline-block;
  padding: 3px 10px;
  border-radius: 999px;
  background: ${({ $bg }) => $bg};
  color: ${({ $fg }) => $fg};
  white-space: nowrap;
  font-weight: 500;
`;
